import React from 'react';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import { DocumentItem } from '../../../../graphql/graphql';
import styles from './DiscourseActions.module.scss';

interface Props {
	onConnectDocument: () => void;
	onConnectTravel: () => void;
	showCreateSickLeave: boolean;
	sickLeaveCreateDisabled: boolean;
	onOpenSickLeaveCreate: () => void;
	sickLeaveUrl?: string;
	canEditCareClaims: boolean;
	activeDiscourseId: string;
	mainDiagnosis?: DocumentItem;
	openCareClaimModal: (
		discourseId: string,
		discourseMainDiagnosis?: DocumentItem,
	) => void;
}

const DiscourseActions: React.FC<Props> = ({
	onConnectDocument,
	onConnectTravel,
	showCreateSickLeave,
	sickLeaveCreateDisabled,
	onOpenSickLeaveCreate,
	sickLeaveUrl,
	canEditCareClaims,
	activeDiscourseId,
	mainDiagnosis,
	openCareClaimModal,
}) => {
	return (
		<div className={styles.actions}>
			<LinkButton
				title='component.discourseControls.connectDocument'
				theme={Theme.BLUE}
				onClick={onConnectDocument}
			/>
			<LinkButton
				title='component.discourseControls.connectTravel'
				theme={Theme.BLUE}
				onClick={onConnectTravel}
			/>
			{showCreateSickLeave && (
				<LinkButton
					title='component.discourse.createNewSickLeave'
					theme={Theme.BLUE}
					disabled={sickLeaveCreateDisabled}
					onClick={onOpenSickLeaveCreate}
				/>
			)}
			{sickLeaveUrl && (
				<LinkButton
					title='component.discourse.viewSickLeave'
					theme={Theme.BLUE}
					href={sickLeaveUrl}
				/>
			)}
			{canEditCareClaims && (
				<LinkButton
					title='component.discourse.editMedicalProcedures'
					theme={Theme.BLUE}
					onClick={() => openCareClaimModal(activeDiscourseId, mainDiagnosis)}
				/>
			)}
		</div>
	);
};

export default DiscourseActions;
